export const PERMISSIONS = {
  TECHNICAL_ADMINISTRATION: 'TECHNICAL_ADMINISTRATION',
  PERMISSIONS_MANAGEMENT: 'PERMISSIONS_MANAGEMENT',
  LEARNING_SITE_CUSTOMIZATIONS: 'LEARNING_SITE_CUSTOMIZATIONS',
  MANAGE_EMAIL_TEMPLATES: 'MANAGE_EMAIL_TEMPLATES',
  LEARNER_MANAGEMENT: 'LEARNER_MANAGEMENT',
  GROUP_ADMINISTRATION: 'GROUP_ADMINISTRATION',
  CONTENT_SHARING_VIA_GROUP: 'CONTENT_SHARING_VIA_GROUP',
  SERIES_MANAGEMENT: 'SERIES_MANAGEMENT',
  MODULE_SHARING: 'MODULE_SHARING',
  MODULE_DEVELOPMENT: 'MODULE_DEVELOPMENT',
  MODULE_MANAGEMENT: 'MODULE_MANAGEMENT',
  MANAGE_SUBORDINATES: 'MANAGE_SUBORDINATES',
  CONDUCT_REVIEWS: 'CONDUCT_REVIEWS',
  LEARNING_ACTIVITES_GAMEPLAY: 'LEARNING_ACTIVITES_GAMEPLAY',
  SERIES_VIEW_ANALYTICS: 'SERIES_VIEW_ANALYTICS',
  MODULE_VIEW_ANALYTICS: 'MODULE_VIEW_ANALYTICS',
  MANAGER_VIEW_ANALYTICS: 'MANAGER_VIEW_ANALYTICS',
  GROUP_VIEW_ANALYTICS: 'GROUP_VIEW_ANALYTICS',
  LEARNER_VIEW_ANALYTICS: 'LEARNER_VIEW_ANALYTICS',
  VIEW_CUSTOM_REPORT: 'VIEW_CUSTOM_REPORT',
  CREATE_CUSTOM_REPORT: 'CREATE_CUSTOM_REPORT',
  BOOKMARK_REPORT_FOR_MANAGERS: 'BOOKMARK_REPORT_FOR_MANAGERS',
  BOOKMARK_REPORT_FOR_ADMINS: 'BOOKMARK_REPORT_FOR_ADMINS',
  MANAGER_VIEW_ANALYTICS_ADMIN_SITE: 'MANAGER_VIEW_ANALYTICS_ADMIN_SITE',
  VIEW_AUTOMATION_RULES: 'VIEW_AUTOMATION_RULES',
  MANAGE_AUTOMATION_RULES: 'MANAGE_AUTOMATION_RULES',
  EDIT_AUTOMATION_RULES: 'EDIT_AUTOMATION_RULES',
  COORDINATE_PARTNER_GROUPS: 'COORDINATE_PARTNER_GROUPS',
  CREATE_EDIT_TAGS: 'CREATE_EDIT_TAGS',
  APPLY_TAGS: 'APPLY_TAGS',
  VIEW_COMPETENCY_REPORT: 'VIEW_COMPETENCY_REPORT',
  VIEW_OVERVIEW_DASHBOARD: 'VIEW_OVERVIEW_DASHBOARD',
  TAG_ANALYTICS: 'TAG_ANALYTICS',
  CATEGORY_MANAGEMENT: 'CATEGORY_MANAGEMENT',
  MANAGE_ACCREDITATIONS: 'MANAGE_ACCREDITATIONS',
  SCOPED_LEARNER_MANAGEMENT_EDIT: 'SCOPED_LEARNER_MANAGEMENT_EDIT',
  SCOPED_LEARNER_MANAGEMENT_VIEW: 'SCOPED_LEARNER_MANAGEMENT_VIEW',
};

export const ENTITIES = {
  PROGRAM: 'program',
  MODULES: 'modules',
  LEARNERS: 'learners',
  PERMISSIONS: 'permissions',
  CATEGORY: 'programCategory',
  GROUPS: 'groups',
  ACCREDITATION: 'accreditation',
};

export const ACTIONS = {
  READ: 'read',
  CREATE: 'create',
  UPDATE: 'update',
  UPDATE_RELATION: 'updateRelation',
  DELETE: 'delete',
  ARCHIVE: 'archive',
  COPY: 'copy',
  MOVE: 'move',
  PUBLISH: 'publish',
  INVITE: 'invite',
  INVITE_EXISTING: 'inviteExisting',
  VIEW_ANALYTICS: 'viewAnalytics',
  VIEW_COMPETENCY_ANALYTICS: 'viewCompetencyAnalytics',
};

export const DEFAULT_SUBJECT_NAME = (item: string) => item;

export const DEFAULT_CONTEXT_PERMISSION = { DENY: [], ALLOW: [], OVERRIDE: [] };

export const DEAFAULT_PROP_GENERATOR = (props: {}) => ({
  contextPermissions: DEFAULT_CONTEXT_PERMISSION,
});
